// extracted by mini-css-extract-plugin
export default {"description":"YourReportsView_description__WPyjU"};